<template>
  <div class="loading">
    <i class="loading__dot"></i>
    <i class="loading__dot"></i>
    <i class="loading__dot"></i>
  </div>
</template>

<script>
export default {
  name: 'Loader',
}
</script>

<style lang="sass">
.loading
    display: flex
    justify-content: center
    align-items: center
    +size(100%, auto)
    margin-bottom: 10rem

    &__dot
        +size(5px)
        border-radius: 100%
        background-color: $black
        margin: 0 2.5px
        display: flex
        +remove-margin-h

        &:nth-child(1)
            animation: loading-1 1.5s ease-in infinite

        &:nth-child(2)
            animation: loading-2 1.5s ease-in infinite

        &:nth-child(3)
            animation: loading-3 1.5s ease-in infinite


@keyframes loading-1
  0%
    transform: translateY(0)
  20%
    transform: translateY(-5px)
  40%
    transform: translateY(0)
  60%
    transform: translateY(0)
  80%
    transform: translateY(0)
  100%
    transform: translateY(0)

@keyframes loading-2
  0%
    transform: translateY(0)
  10%
    transform: translateY(0)
  30%
    transform: translateY(-5px)
  50%
    transform: translateY(0)
  80%
    transform: translateY(0)
  100%
    transform: translateY(0)

@keyframes loading-3
  0%
    transform: translateY(0)
  20%
    transform: translateY(0)
  20%
    transform: translateY(0)
  40%
    transform: translateY(-5px)
  60%
    transform: translateY(0)
  100%
    transform: translateY(0)
</style>
